var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.8 73.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "be601243-f43c-46f4-82f6-a0f4030c1e2a",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "af8b2ab8-a60e-4dd7-bad9-74e206a7865d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.05,86.6a28.83,28.83,0,0,1-11.57-2.08,17.5,17.5,0,0,1-7.31-5.47,12,12,0,0,1-2.52-7.3,8.05,8.05,0,0,1,2.1-6,7.77,7.77,0,0,1,5.7-2.07A7.58,7.58,0,0,1,19,65.62,7.37,7.37,0,0,1,21,71.1V75a7.09,7.09,0,0,0,1.93,5.3q1.92,1.9,5.87,1.9a9.85,9.85,0,0,0,7.17-3.38q3.28-3.37,5.25-11.07t2-20.7q0-11.2-1.73-17.58t-4.67-9a9.65,9.65,0,0,0-6.65-2.67,9.9,9.9,0,0,0-8.33,4.17q-3.12,4.18-3.12,12.68,0,7.9,3.43,12a11.09,11.09,0,0,0,9,4.13,13.18,13.18,0,0,0,6.3-1.55A13.7,13.7,0,0,0,42.15,45a11.9,11.9,0,0,0,2.15-6.1l2.9.8a14.49,14.49,0,0,1-3.15,8.42,21,21,0,0,1-7.8,6.13A25,25,0,0,1,25.4,56.5a26.14,26.14,0,0,1-11.48-2.35A17.18,17.18,0,0,1,6.4,47.3,21.08,21.08,0,0,1,3.75,36.4,22.11,22.11,0,0,1,7,24.37a22,22,0,0,1,9.15-8.07,31.22,31.22,0,0,1,13.9-2.9,28,28,0,0,1,15.43,4.1A25.85,25.85,0,0,1,55.2,29.22,45.35,45.35,0,0,1,58.55,47.5q0,12.7-3.82,21.42a29,29,0,0,1-11,13.2A30.55,30.55,0,0,1,27.05,86.6Z",
    transform: "translate(-3.75 -13.4)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.bf185c46e69e73144c0d5de35e9f08d6.svg";
export { ForwardRef as ReactComponent };